import Aboutus from "../../components/Aboutus/Aboutus.js";


const About = () => {
  return (
    <div className="mx-auto">
      <Aboutus />
    </div>
  );
};

export default About;
